import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";
import {PredictionAthleteDetails} from "./prediction.athlete-details";
import {EntityLogo} from "../../../logos/entity-logo";
import {PROPOSITION_BETS} from "../../../../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";
import {PREDICTION_WIDGET} from "../../../../../widgets/prediction-widget/predictions-widget.consts";

export const PredictionAthlete = observer(({prediction, controller}) => {
  const {device: {isSmallView}} = controller;
  const {athlete, gameId, odds} = prediction;

  const containerProps = {
    className: classNames(styles.athlete),
    onClick: () => controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick, {athleteId: prediction?.athleteId, lineTypeId: odds.lineTypeId, gameId})
  }

  const logoProps = {
    entity: athlete,
    width: isSmallView ? PREDICTION_WIDGET.LOGO_SIZES.ATHLETE.mobile : PREDICTION_WIDGET.LOGO_SIZES.ATHLETE.desktop,
    height: isSmallView ? PREDICTION_WIDGET.LOGO_SIZES.ATHLETE.mobile : PREDICTION_WIDGET.LOGO_SIZES.ATHLETE.desktop
  }

  return (
    athlete ? <div {...containerProps}>
      <div className={classNames(styles.athlete_logo)}>
        <EntityLogo {...logoProps}/>
      </div>
      <PredictionAthleteDetails prediction={prediction}/>
    </div> : null
  )
});
